import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c9282c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }

interface IProps {
    title: string;
    subtitle?: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("h6", _hoisted_3, _toDisplayString(__props.subtitle), 1)
  ]))
}
}

})